import {remCalc} from '../../_utils'

export default {
    parts: ['promoTile', 'promoBanner'],

    baseStyle: {
        promoTile: {
            container: {
                width: '100%',
                height: 'auto',
                maxHeight: remCalc(79),
                alignItems: 'center',
                gap: 'small.base',
            },
            imageContainer: {
                width: remCalc(79),
                height: remCalc(79),
                flexShrink: '0',
                alignItems: 'flex-start',
                justifyContent: 'center',
            },
            subContainer: {
                //flex: '1',
                width: '100%',
                // alignItems: 'center',
                justifyContent: 'space-between',
                // minWidth: '0',
                // overflow: 'hidden',
            },
            infoContainer: {
                flexDir: 'column',
                justifyContent: 'center',
                alignItems: 'flex-start',
                gap: 'xsmall.base',
                flexShrink: '0',
                overflow: 'hidden',
            },
            productName: {
                textStyle: 'body-medium',
                fontWeight: 'normal',
                color: 'text.default',
                maxWidth: {
                    base: remCalc(120),
                    sm: remCalc(120),
                    md: remCalc(200),
                    lg: remCalc(200),
                },
            },
            productDescription: {
                textStyle: 'body-xsmall',
                fontWeight: 'normal',
                color: 'text.secondary',
            },
        },
        promoBanner: {
            container: {
                bg: 'background.brand',
                width: 'fit-content',
                maxWidth: remCalc(168),
                paddingY: remCalc(6),
                paddingX: 'xsmall.base',
                height: remCalc(20),
                align: 'center',
                justify: 'center',
                textAlign: 'center',
            },
            messageContainer: {
                gap: 'small.base',
                flexDir: {base: 'column', lg: 'row'},
                justifyContent: {
                    base: 'flex-start',
                    lg: 'center',
                },
            },
            labelText: {
                flex: '1 0 0',
                textStyle: 'body-xxsmall',
                fontWeight: 'bold',
                color: 'text.inverse',
            },
            bannerText: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                color: 'text.default',
            },
            bannerButton: {
                textStyle: 'body-small',
                fontWeight: 'normal',
                justifyContent: 'flex-start',
            },
        },
    },
}
